import state from '@/store/hoPaginatedList/state';

export default {
  ...state,
  paginationParams: {
    ...state.paginationParams,
    paginated: 1,
  },
};
